import React from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfoCircle,
  faRightFromBracket,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

interface LogoutModalProps {
  show: boolean;
  onLogoutNow: () => void;
  onLogoutLater: () => void;
}

const LogoutModal: React.FC<LogoutModalProps> = ({
  show,
  onLogoutNow,
  onLogoutLater,
}) => {
  return (
    <Modal
      show={show}
      onHide={onLogoutLater}
      centered
      className="fade"
      size="lg"
    >
      <Modal.Header className="border-0 pb-0">
        <div className="d-flex justify-content-center w-100">
          <div className="rounded-circle bg-primary bg-opacity-10 p-3 mb-3">
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="text-primary fa-2x"
            />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="text-center px-4 pt-0">
        <h4 className="mb-3">Atualização de Perfil</h4>
        <p className="mb-4 text-secondary">
          Você atualizou seu próprio perfil de usuário. Para que as alterações
          tenham efeito completo, é necessário fazer login novamente.
        </p>
        <div className="d-flex justify-content-center mb-4">
          <div
            className="border rounded p-3 mx-2 text-center"
            style={{ width: "45%", cursor: "pointer" }}
            onClick={onLogoutNow}
          >
            <div
              className="rounded-circle bg-danger bg-opacity-10 p-2 mx-auto mb-2"
              style={{
                width: "48px",
                height: "48px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon
                icon={faRightFromBracket}
                className="text-danger fa-lg"
              />
            </div>
            <h6 className="mb-1">Sair Agora</h6>
            <small className="text-muted">
              Aplicar mudanças imediatamente
            </small>
          </div>
          <div
            className="border rounded p-3 mx-2 text-center"
            style={{ width: "45%", cursor: "pointer" }}
            onClick={onLogoutLater}
          >
            <div
              className="rounded-circle bg-secondary bg-opacity-10 p-2 mx-auto mb-2"
              style={{
                width: "48px",
                height: "48px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon
                icon={faClock}
                className="text-secondary fa-lg"
              />
            </div>
            <h6 className="mb-1">Sair Depois</h6>
            <small className="text-muted">Continuar usando o sistema</small>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 d-flex justify-content-center">
        <small className="text-muted text-center">
          Nota: Algumas alterações podem exigir que você faça login novamente
          para serem aplicadas corretamente.
        </small>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoutModal;
